import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";

export function StreamPresetsPromo() {
  const navigate = useNavigate();

  const handleLaunch = async () => {
    try {
      await axios.get(`${API}/auth/me`, {
        withCredentials: true,
      });

      navigate("/stream-presets");
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/members?next=%2Fstream-presets");
      } else {
        alert(
          "Unable to check your membership right now. Please try again."
        );
      }
    }
  };

  return (
    <section
      id="stream-presets"
      className="relative z-10 mx-auto max-w-6xl px-4 py-20"
    >
      <div className="relative overflow-hidden rounded-2xl border border-green-500/40 bg-black/85 p-8 text-center shadow-[0_0_45px_rgba(34,197,94,0.12)] md:p-14">

        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-green-500/10 via-transparent to-green-950/20" />

        <div className="relative z-10 space-y-6">

          <p className="font-mono text-xs uppercase tracking-[0.3em] text-green-400">
            DORIANTELIVE // CREATOR TOOLS
          </p>

          <h2 className="text-3xl font-black uppercase tracking-tight text-white md:text-5xl">
            Take Control of Your Stream.
          </h2>

          <p className="mx-auto max-w-2xl text-base leading-relaxed text-white/70">
            Five platforms. One command center. Your presets, your way.
            Manage stream titles, descriptions, categories, and tags
            across Twitch, YouTube, TikTok, Facebook, and Kick.
          </p>

          <div className="mx-auto max-w-xl rounded-xl border border-green-500/30 bg-green-500/10 p-6">
            <h3 className="text-2xl font-black uppercase text-green-400">
              100% Free for Members!
            </h3>

            <p className="mt-3 text-lg font-semibold text-white">
              Membership is FREE. The app is FREE.
            </p>

            <p className="mt-2 text-sm text-white/70">
              No subscriptions. No hidden fees. No catches.
            </p>

            <p className="mt-3 font-semibold italic text-green-300">
              A gift from me to you!
            </p>
          </div>

          <button
            type="button"
            onClick={handleLaunch}
            className="rounded-xl border border-green-400 bg-green-500 px-8 py-4 font-black uppercase tracking-wider text-black transition-all hover:bg-green-400 hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]"
          >
            Launch My Stream Manager
          </button>

          <p className="text-xs text-white/45">
            Your personal presets are saved securely to your member account.
          </p>

        </div>
      </div>
    </section>
  );
}